import axios, { AxiosError } from "axios"
import {
  requestInterceptorErrorSecurityCredentials,
  requestInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
  responseInterceptorSuccessCredentials,
} from "interceptors"
import { LIST_PATH, OFFICE_PATH } from "../../constants/paths"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CONFIGURATION_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getOfficesService = async () => {
  try {
    const result = await instance.get(OFFICE_PATH + LIST_PATH)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const createOfficeService = async (office: any) => {
  try {
    const result = await instance.post(OFFICE_PATH, office)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data?.message)
  }
}

export const deleteOfficeService = async (id: any) => {
  try {
    const result = await instance.delete(OFFICE_PATH + `/${id}`)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const editOfficeService = async (id: number, office: any) => {
  try {
    const result = await instance.put(OFFICE_PATH + `/${id}`, office)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data?.message)
  }
}
